module.exports = __webpack_public_path__ + "OpenSans-ExtraBold-12e2ed7a180e601bff44253d4c7062ad.woff";